export default {"src":"/_next/static/media/bullet_icon.1ab68108.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};